export default "/img/MZ.fb8a8ddffe0ff83ceff52957320b2629.png";